import { KEYWORD_TRIGGERED_BANNER_REQUESTED } from "./const";

function action() {
  return {
    type: KEYWORD_TRIGGERED_BANNER_REQUESTED,
  };
}

export default action;
